import { buildUserOption } from '@witmetrics/unison-core';
import type {
  DecoratedLabUser,
  DecoratedPracticeUser,
} from '@witmetrics/utils';

export const classes = {
  filtersWrapper: 'flex',
  filtersList: 'w-[225px]',
  buttonsWrapper: 'px-4 py-4 place-between',
  resetButton: 'px-3',
  applyButton: 'px-6',
};

export function formatUserOption({
  user,
}: DecoratedPracticeUser | DecoratedLabUser) {
  return buildUserOption(user);
}
